import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'

import { Signature, Policy, xAmzDate, dateYMD } from './_S3/ReactS3'
import { RBACModal } from '../Components'

import ItemList from './_ItemList'
import ProgressModal from './_ProgressModal'
import Completed from './_Completed'

import firebase from '../Configs/firebase'

class FolderView extends Component{
    constructor(props){
        super(props)
        this.state = {
            files:null,
            fileCondition: false,
            filesType:null,
            isUploading:false,
            uploadPercentage:0,
            isSavingFirebase: false,
            isProcessCompleted: false,
            isProcessError: false,
            isDisplayCompleted: false,
            isOpenPermissionModal:false,
            selectedFile:null
        }

        this.handleExpanded = this.handleExpanded.bind(this)
        this.handleLogout = this.handleLogout.bind(this)
        this.handleFileUpload = this.handleFileUpload.bind(this)
        this.upload = this.upload.bind(this)
        this.dismissUpload = this.dismissUpload.bind(this)
        this.setDefault = this.setDefault.bind(this)
        this.handleClosePermissionModal = this.handleClosePermissionModal.bind(this)
        this.handleManagePermision = this.handleManagePermision.bind(this)

        this.displayCompletedTimeout = null
    }

    setDefault(){
        const { user } = this.props
        this.setState({
            files:null,
            fileCondition: false,
            filesType:null,
            isUploading:false,
            uploadPercentage:0,
            isSavingFirebase: false,
            isProcessCompleted: false,
            isProcessError: false,
            isDisplayCompleted: false,
        })
        this.props.setUser(user)
    }

    handleExpanded(e,id){
        e.preventDefault()
        var element = document.getElementById(id)
        var content = document.getElementById('content-'+id)

        if(element.className === 'fas fa-chevron-up is-dropdown'){
            element.className = 'fas fa-chevron-down is-dropdown'
        }
        else{
            element.className = 'fas fa-chevron-up is-dropdown'
        }

        if (content.style.display === "block") {
            content.style.display = "none";
        }
        else {
            content.style.display = "block";
        }
    }

    handleLogout(){
        const { setUser } = this.props
        firebase.auth().signOut()
        .then(()=>{
            setUser(null)
        })
    }

    validateProjection(prjFile){
        var fileReader = new FileReader()
        var res = true
        return new Promise((resolve,reject)=>{
            fileReader.onload = () =>{
                if( !fileReader.result.includes('GCS_WGS_1984') ){
                    res = false
                    resolve(res)
                }
                resolve(res)
            }
            fileReader.readAsText(prjFile)
        })
    }

    async validateFile(file) {
        var mode = null
        var allowFile = ["shp", "shx", "dbf", "qix", "prj", "sbn", "sbx", "fbn", "fbx", "ain", "aih", "ixs", "mxs", "atx", "xml", "cpg", "qix", "sld"]
        if ( file === undefined || file === null) {
            return {
                result: false,
                message: 'กรุณาใส่ไฟล์'
            };
        }
        if ( file.size > 1073741824 ) {
            return {
                result: false,
                message: 'กรุณาเลือกไฟล์ขนาดไม่เกิน 1 GB'
            };
        }

        if(file.length > 1 ){
            for(var i = 0 ; i < file.length ; i++){
                if(file[i].type !== ''){
                    if ( ! allowFile.includes(file[i].name.split('.')[1]) ){
                        return {
                            result: false,
                            message: 'กรุณาใส่ไฟล์นามสกุลที่กำหนด'
                        }
                    }
                }
                if( file[i].name.split('.')[1] === 'prj' ){
                    var result = await this.validateProjection(file[i])
                    if( !result ){
                        return {
                            result: false,
                            message: 'กรุณาเปลี่ยน Projection เป็น WGS 84'
                        }
                    }
                }
                mode = 'shapefile'           
            }
        }
        else if(file.length === 1 ){
            if(file[0].type !== 'image/tiff'){
                return {
                        result: false,
                        message: 'กรุณาใส่ไฟล์นามสกุลที่กำหนด'
                }
            }
            mode = 'tiff'
        }
        return { 
            result: true,
            type:mode    
        }
    }

    async handleFileUpload(event){
        const file = event.target.files;
        const validation = await this.validateFile(file);
        if ( validation.result === false ) {
            if (event.target !== null) event.target.value = null
            this.setState({
                    files: null ,
                    fileCondition: false,
                    filesType :null
            })
            alert(validation.message);
            return
        }
        this.setState({
            files:file ,
            fileCondition:true ,
            filesType:validation.type,
        })
    }

    upload(){
        const { files, filesType } = this.state
        const { user } = this.props

        const fileArr = [...files]
        fileArr.sort((a,b)=>parseFloat(a.size) - parseFloat(b.size))
        
        const config = {
            bucketName: 'ling-156609',
            dirName: user.uid,  
            region: 'ap-southeast-1',
            accessKeyId: 'AKIASKZ3SXVV4BJKR5BJ',
            secretAccessKey: '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',
        }

        const validation = this.validateFile(files);
        if ( validation.result === false ) {
            this.setState({
                    files: null ,
                    fileCondition: false,
                    filesType :null
            })
            alert(validation.message);
            return
        }

        if( files !== null ){
            var arrFilename = []
            var uploadSize = 0
            var transactionId = ''
            var foldername = null
            var uploadPromise = []
            var fileMetadataArr = []

            for(var i =0; i< files.length; i++){

                uploadSize += files[i].size
                arrFilename.push(files[i].name)
            
                const fd = new FormData();
                const key = `${config.dirName ? config.dirName + "/" : ""}${files[i].name}`;
                const url = `https://${config.bucketName}.s3.amazonaws.com/`;

                fd.append("key", key);
                fd.append("acl", "public-read");
                fd.append("Content-Type", 'multipart/form-data');
                fd.append("x-amz-meta-uuid", "14365123651274");
                fd.append("x-amz-server-side-encryption", "AES256");
                fd.append("X-Amz-Credential", `${config.accessKeyId}/${dateYMD}/${config.region}/s3/aws4_request`);
                fd.append("X-Amz-Algorithm", "AWS4-HMAC-SHA256");
                fd.append("X-Amz-Date", xAmzDate);
                fd.append("x-amz-meta-tag", "");
                fd.append("Policy", Policy.getPolicy(config));
                fd.append("X-Amz-Signature", Signature.getSignature(config, dateYMD, Policy.getPolicy(config)));    
                fd.append ("file", files[i]);

                var meta = {
                    name : files[i].name,
                    size : files[i].size,
                    path : `${url}${config.dirName ? config.dirName + "/" : ""}${files[i].name}`
                }

                var params = {
                    headers: {
                        fd
                    }
                }

                if( files[i].name === fileArr[fileArr.length-1].name){
                    params = {
                        headers: {
                            fd
                        },
                        onUploadProgress: function( progressEvent ){
                            this.setState({
                                uploadPercentage: parseInt( Math.round(( progressEvent.loaded * 100 ) / progressEvent.total ),10)
                            })
                        }.bind(this)
                    };
                }
                fileMetadataArr.push(meta)
                uploadPromise.push(axios.post(url,fd, params))
            }

            if(user.available_storage - uploadSize < 0) {
                throw new Error('คุณเหลือพื้นที่ไม่เพียงพอ กรุณาติดต่อทีมงานเพื่อขอเพิ่มพื้นที่')
            }

            foldername = prompt("ตั้งชื่อไฟล์ : ",files[0].name.split('.')[0])

            firebase.firestore().collection('transaction_upload').add({
                name: user.name,
                uid:user.uid,
                created_date: new Date(),
                file:arrFilename,
                folder_name:foldername,
                phone:user.phone,
                size:uploadSize
            })
            .then(doc=>{
                transactionId = doc.id
                this.setState(({
                    isUploading: true,
                    uploadPercentage: 0
                }))
                return  Promise.all(uploadPromise)
            })
            .then((res)=>{
                this.setState(({
                    isUploading: false,
                    isSavingFirebase: true,
                    uploadPercentage: 100
                }))

                return firebase.firestore().collection('drone_hostings').add({
                    name : user.name,
                    folder_name:foldername,
                    uid:user.uid,
                    phone:user.phone,
                    created_date: new Date(),
                    file : fileMetadataArr,
                    type:filesType
                });
            })
            .then(()=>{
                return firebase.firestore().collection('users').doc(user.uid).update({
                    available_storage:user.available_storage - uploadSize
                })
            })
            .then(()=>{
                return firebase.firestore().collection('transaction_upload').doc(transactionId).delete()
            })
            .then(()=>{
                this.setState(({
                    isSavingFirebase: false,
                    isProcessCompleted: true,
                    isProcessError: false,
                    isDisplayCompleted:true
                }))
            })
            .catch(err=>{
                this.setState(({
                    isSavingFirebase: false,
                    isProcessCompleted: false,
                    isProcessError: true
                }))
            })
        }    
    }

    dismissUpload() {
        this.setState(({
            isUploading: false,
            isSavingFirebase: false,
            isProcessCompleted: false,
            isProcessError: false,
            uploadPercentage: 0
        }))
    }

    handleManagePermision(drone){
        if(drone === ''){
            return alert('คุณยังไม่สามารถจัดการสิทธิ์ของไฟล์นี้ได้')
        }
        this.setState({
            isOpenPermissionModal:true,
            selectedFile:drone
        })
    }

    handleClosePermissionModal(){
        this.setState({
            isOpenPermissionModal:false,
            selectedFile:null
        })
    }

    render(){
        const { user } = this.props
        const { files, isUploading, isSavingFirebase, isProcessCompleted, isProcessError, isDisplayCompleted, uploadPercentage, isOpenPermissionModal, selectedFile } = this.state
        const isProcessing = isUploading === true || isSavingFirebase === true || isProcessCompleted === true || isProcessError === true;

        var filesname = 'ยังไม่ได้เลือกไฟล์'
        var userPhoto = <img className="user-photo" src="/Images/profile@3x.png" alt="User" width="48" height="48"></img>
        var size = ( user !== null ) ? (user.available_storage/1073741824).toFixed(2) : '0 GB'

        var modal = null
        var formData = null
        
        if( files !== null ){
            filesname = files[0].name.split('.')[0]
        }

        if( user !== null && user.photoURL !== null){
            userPhoto = <div className="user-photo"> 
                            <img src={user.photoURL} alt="user" ></img>
                        </div>
        }

        if ( isProcessing === true && isDisplayCompleted === false ) {
            modal = (
                <ProgressModal 
                    isOpen={true} 
                    isUploading={isUploading} 
                    isSavingFirebase={isSavingFirebase} 
                    isProcessCompleted={isProcessCompleted} 
                    isProcessError={isProcessError} 
                    uploadPercentage={uploadPercentage} 
                    dismissUpload={this.dismissUpload} />
            );
        }

        if ( isOpenPermissionModal === true ){
            modal = (
                <RBACModal
                    isOpen={isOpenPermissionModal}
                    dismissModal={this.handleClosePermissionModal}
                    selectedFile={selectedFile}
                    user={user}
                />

            )
        }

        var content = (
                <div className="container">
                    <div className="box">
                        <div className="user-profile box">
                            <div className="is-overflow">
                                <div className="photo-and-button " >
                                    {userPhoto}
                                    <div className="is-rounded is-outlined button-logout text-grey"  onClick={this.handleLogout}>ออกจากระบบ</div>
                                </div>
                                <div className="name-and-storage">
                                    <label>{user.name}</label>
                                    <label>พื้นที่เหลือ : {size} GB</label>
                                </div>
                                <div className="upload-form">
                                    <div className="field-is-right field" >
                                        <div className="UploadFormInputFileBox">
                                            <label className="UploadFormInputFileLabel file-label">
                                                <input className="file-input is-max-width" type="file" accept="image/*, .shp, .shx, .dbf, .qix, .prj, .sbn, .sbx, .fbn, .fbx, .ain, .aih, .ixs, .mxs, .atx, .xml, .cpg, .qix, .sld" multiple="multiple" onChange={this.handleFileUpload}></input>
                                                <span className="UploadFormInputFileCta file-cta is-max-width">
                                                <span className="file-icon"><i className="fas fa-upload"></i></span>                                                
                                                <span className="UploadFormInputFileLabelText file-label">เลือกไฟล์</span>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="filename-and-button">
                                        <div className="button-upload" onClick={this.upload}>
                                            <div className="button is-primary is-rounded is-outlined">Upload</div>
                                        </div>
                                        <div className="file-selected" >
                                            <label>{filesname}</label>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                            <div className="center">
                                <br/>
                                <label>เมื่อสมัครใช้งาน แสดงว่าคุณยินยอมตาม <Link className="has-text-primary" to="/upload/terms" target="_blank" rel="noopener noreferrer">ข้อกำหนดในการให้บริการ</Link> และ <Link className="has-text-primary" to="/upload/privacy_policy" target="_blank" rel="noopener noreferrer">นโยบายข้อมูล</Link> ของเรา</label>
                            </div>

                        </div>
                        <div>
                            <button className="collapsible" onClick={(e)=>{this.handleExpanded(e,'dropdownIconTiff')}}>
                                <i className="far fa-folder-open fa-1x"></i>
                                <label> GeoTiff Images</label>
                                <i id="dropdownIconTiff" className="fas fa-chevron-down is-dropdown"></i>
                            </button>
                            <div id="content-dropdownIconTiff" className="folder-content">
                                <ItemList folder='tiff' user={user} setUser={this.props.setUser} handleManagePermision={this.handleManagePermision} ></ItemList>
                            </div>
                            <hr/>
                            <button className="collapsible" onClick={(e)=>{this.handleExpanded(e,'dropdownIconShape')}}> 
                                <i className="far fa-folder-open fa-1x"></i>
                                <label> Shapefiles </label>
                                <i id="dropdownIconShape" className="fas fa-chevron-down is-dropdown"></i>
                            </button>
                            <div id="content-dropdownIconShape" className="folder-content">
                                <ItemList folder='shapefile' user={user} setUser={this.props.setUser} handleManagePermision={this.handleManagePermision} ></ItemList>
                            </div><br/><br/>
                            <div className="video-and-information">
                                <div className="video-max-width">
                                <iframe title="upload" width="560" height="315" src="https://www.youtube.com/embed/6Rlp6l4713g" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>                                </div>
                                <div className="information-max-width">
                                    <br/><br/>
                                    <h2>ข้อแนะนำการอัพโหลดข้อมูล GIS</h2>
                                    <li> EPSG 4326 / WGS 84</li>
                                    <li> Encoding UTF-8</li>
                                    <li> Format Supported Vector .shp</li>
                                    <li> Format Supported Raster .tiff, .geotiff</li>
                                </div>
                            </div>
                        </div>
                            
                    </div>
                </div>
        )
        
        if ( isDisplayCompleted === true ) {
            formData = {
                name:user.name,
                phone:user.phone,
                file:files
            }
            content = (
                <Completed  formData={formData} setDefault={this.setDefault}/>
            )
        }

        return (
            <section className="ManagementForm section">
                {content}
                {modal}
            </section> 
        )
    }
}

export default FolderView


// WEBPACK FOOTER //
// ./src/PageManagement/_FolderView.js